// Central brand asset URLs supplied by the Temple owner.
// Do NOT regenerate, redraw, or substitute these assets.

// Gold "TEMPLE OF THE HUMAN HEART · Awaken. Re-Member. Return." brand logo.
export const OFFICIAL_LOGO =
  "https://customer-assets-jt897jd0.emergentagent.net/job_divine-sanctuary-10/artifacts/3z118x0l_f0b72c74-0f38-4e63-a9df-1c1ef2eea3d4.png";

// Rev. Yisra'el portrait with embedded "Temple of the Human Heart Radio" logo.
export const RADIO_HERO_PORTRAIT =
  "https://customer-assets-jt897jd0.emergentagent.net/job_divine-sanctuary-10/artifacts/jn6n9etj_ChatGPT%20Image%20Sep%2012%2C%202026%20at%2011_15_17%20PM.png";

// Yisra'el Apriale founder portrait (square) with embedded gold script
// "Yisra'el Apriale · Love is the Doctrine." — used unchanged on the About page.
export const FOUNDER_PORTRAIT =
  "https://customer-assets-jt897jd0.emergentagent.net/job_divine-sanctuary-10/artifacts/hk1t5h6n_ChatGPT%20Image%20Sep%2021%2C%202026%20at%2010_18_43%20PM.png";
